import moment from 'moment';

const zonedMoment = (tz, value) => {
  const m = moment(value);

  // NOTE: if the tz is null or undefined, the tz() function returns a non-moment value instead of setting zone
  m.tz(tz);

  return m;
};

export default zonedMoment;
